import styled, { css } from 'styled-components';

import { Media } from '../../assets/Mixins.style';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
`;

export const Box = styled.div`
  position: fixed;
  top: 129px;
  right: 0;
  display: flex;
  flex-direction: column;
  width: 250px;
  max-height: 350px;
  border-radius: 10px 0 0 10px;
  background: ${(props) => props.theme.background};
  border-top: 1px solid ${(props) => props.theme.border};
  border-bottom: 1px solid ${(props) => props.theme.border};
  border-left: 1px solid ${(props) => props.theme.border};
  box-shadow: 0 3px 6px 0 ${(props) => props.theme.shadow};
  z-index: 1;
  overflow-x: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }

  ${Media.lg`
    position: relative;
    top: initial;
    right: initial;
    max-height: initial;
    width: 100%;
    border-radius: 10px;
    border-right: 1px solid ${(props) => props.theme.border};
    margin-bottom: 20px;
  `}
`;

export const Item = styled.span`
  position: relative;
  display: block;
  padding: 15px 30px;
  transition: 0.2s all;
  color: ${(props) => props.theme.color};
  font-size: 19px;
  font-weight: 600;
  line-height: 1.2;
  user-select: none;
  text-align: left;
  cursor: pointer;

  ${(props) =>
    props.selected &&
    css`
      color: ${(props) => props.theme.colorOnSelected};
      font-weight: 700;

      ${Media.lg`
        color: ${(props) => props.theme.color};
      `}
    `}

  &:after {
    position: absolute;
    width: auto;
    height: 1px;
    background: ${(props) => props.theme.backgroundLine};
    right: 10px;
    left: 10px;
    bottom: 0;
    z-index: +1;
    content: '';
  }
`;
